module.exports = __webpack_public_path__ + "static/cdgd-4152fb6f7b2145b99c3492554322e804.png";